import { Close as CloseIcon } from "../icons";
import { Link } from "gatsby";
import React from "react";
import ReactModal from "react-modal";

const Modal = ({ children }) => (
  <ReactModal
    contentLabel="Modal"
    onRequestClose={() => window.history.back()}
    isOpen={true}
    className="modal"
    overlayClassName="modal-overlay"
  >
    <Link className="modal__close" to="/work">
      <CloseIcon />
    </Link>
    {children}
  </ReactModal>
);

export default Modal;
